module.exports = __webpack_public_path__ + "static/media/close.9ec8baf2.svg";